import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const StaffRoleGuard = ({ children, allowedRoles = [] }) => {
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkRole = () => {
      const userRole = localStorage.getItem('userRole') || localStorage.getItem('role');
      const staffRole = localStorage.getItem('staffRole');
      
      // Check if user has required role
      const hasAccess = allowedRoles.includes(userRole) || 
                       allowedRoles.includes(staffRole) ||
                       allowedRoles.length === 0; // No restrictions if empty array
      
      if (hasAccess) {
        setAuthorized(true);
      } else {
        // Redirect to appropriate dashboard based on role
        if (userRole === 'super_admin') {
          navigate('/super-admin');
        } else if (userRole === 'tenant_admin') {
          navigate('/tenant-dashboard');
        } else if (staffRole === 'security') {
          navigate('/security-dashboard');
        } else if (staffRole === 'ticketing') {
          navigate('/staff-dashboard');
        } else {
          navigate('/login');
        }
      }
      setLoading(false);
    };

    checkRole();
  }, [allowedRoles, navigate]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: '16px' }}>🔐</div>
          <div style={{ fontSize: '1.2rem', fontWeight: '600' }}>Verifying Access...</div>
        </div>
      </div>
    );
  }

  if (!authorized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        color: 'white'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: '16px' }}>🚫</div>
          <div style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '8px' }}>
            Access Denied
          </div>
          <div style={{ fontSize: '1rem', opacity: 0.9 }}>
            You don't have permission to access this page
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default StaffRoleGuard;